export const FETCH_DECISIONS_REQUESTING = 'decisions/FETCH_DECISIONS_REQUESTING';
export const FETCH_DECISIONS_SUCCESS = 'decisions/FETCH_DECISIONS_SUCCESS';
export const FETCH_DECISIONS_FAILED = 'decisions/FETCH_DECISIONS_FAILED';

export const FETCH_DECISION_DETAIL_REQUESTING = 'decisions/FETCH_DECISION_DETAIL_REQUESTING';
export const FETCH_DECISION_DETAIL_SUCCESS = 'decisions/FETCH_DECISION_DETAIL_SUCCESS';
export const FETCH_DECISION_DETAIL_FAILED = 'decisions/FETCH_DECISION_DETAIL_FAILED';
export const CLEAR_DECISION_DETAIL = 'decisions/CLEAR_DECISION_DETAIL';

export const CREATE_DECISION_REQUESTING = 'decisions/CREATE_DECISION_REQUESTING';
export const CREATE_DECISION_SUCCESS = 'decisions/CREATE_DECISION_SUCCESS';
export const CREATE_DECISION_FAILED = 'decisions/CREATE_DECISION_FAILED';

export const UPDATE_DECISION_REQUESTING = 'decisions/UPDATE_DECISION_REQUESTING';
export const UPDATE_DECISION_SUCCESS = 'decisions/UPDATE_DECISION_SUCCESS';
export const UPDATE_DECISION_FAILED = 'decisions/UPDATE_DECISION_FAILED';

export const DELETE_DECISION_REQUESTING = 'decisions/DELETE_DECISION_REQUESTING';
export const DELETE_DECISION_SUCCESS = 'decisions/DELETE_DECISION_SUCCESS';
export const DELETE_DECISION_FAILED = 'decisions/DELETE_DECISION_FAILED';

export const UPLOAD_DECISIONS_REQUESTING = 'decisions/UPLOAD_DECISIONS_REQUESTING';
export const UPLOAD_DECISIONS_SUCCESS = 'decisions/UPLOAD_DECISIONS_SUCCESS';
export const UPLOAD_DECISIONS_FAILED = 'decisions/UPLOAD_DECISIONS_FAILED';

export const WORKFLOW_ACTION_REQUESTING = 'decisions/WORKFLOW_ACTION_REQUESTING';
export const WORKFLOW_ACTION_SUCCESS = 'decisions/WORKFLOW_ACTION_SUCCESS';
export const WORKFLOW_ACTION_FAILED = 'decisions/WORKFLOW_ACTION_FAILED';

// Pipeline polling (historiques)
export const POLL_HISTORIQUES_UPDATE = 'decisions/POLL_HISTORIQUES_UPDATE';

// Stats dashboard
export const FETCH_STATS_REQUESTING = 'decisions/FETCH_STATS_REQUESTING';
export const FETCH_STATS_SUCCESS = 'decisions/FETCH_STATS_SUCCESS';
export const FETCH_STATS_FAILED = 'decisions/FETCH_STATS_FAILED';

// Admin dashboard
export const FETCH_ADMIN_DASHBOARD_REQUESTING = 'decisions/FETCH_ADMIN_DASHBOARD_REQUESTING';
export const FETCH_ADMIN_DASHBOARD_SUCCESS = 'decisions/FETCH_ADMIN_DASHBOARD_SUCCESS';
export const FETCH_ADMIN_DASHBOARD_FAILED = 'decisions/FETCH_ADMIN_DASHBOARD_FAILED';

// Pipeline
export const FETCH_PIPELINE_REQUESTING = 'decisions/FETCH_PIPELINE_REQUESTING';
export const FETCH_PIPELINE_SUCCESS = 'decisions/FETCH_PIPELINE_SUCCESS';
export const FETCH_PIPELINE_FAILED = 'decisions/FETCH_PIPELINE_FAILED';

// Reassign
export const REASSIGN_DECISIONS_REQUESTING = 'decisions/REASSIGN_DECISIONS_REQUESTING';
export const REASSIGN_DECISIONS_SUCCESS = 'decisions/REASSIGN_DECISIONS_SUCCESS';
export const REASSIGN_DECISIONS_FAILED = 'decisions/REASSIGN_DECISIONS_FAILED';
